<div class="ap-info">
    <p class="ap-section-label" *ngIf="section.label">{{ section.label }}</p>
    <div class="ap-info-panel"
         [class.tone-info]="(section.tone || 'info') === 'info'"
         [class.tone-warning]="section.tone === 'warning'">
        <p class="ap-info-body">{{ section.body }}</p>
    </div>
</div>
